/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pageUpgradeStar.vue?vue&type=template&id=e8313304"
import script from "./pageUpgradeStar.vue?vue&type=script&lang=js"
export * from "./pageUpgradeStar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports